import { render, staticRenderFns } from "./ForumResponseBodyTextOutput.vue?vue&type=template&id=c3db8bce&scoped=true"
import script from "./ForumResponseBodyTextOutput.vue?vue&type=script&lang=js"
export * from "./ForumResponseBodyTextOutput.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseBodyTextOutput.vue?vue&type=style&index=0&id=c3db8bce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3db8bce",
  null
  
)

export default component.exports